(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusDeleteController',Delivery_statusDeleteController);

    Delivery_statusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Delivery_status'];

    function Delivery_statusDeleteController($uibModalInstance, entity, Delivery_status) {
        var vm = this;

        vm.delivery_status = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Delivery_status.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
